import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-placement-reading',
  templateUrl: './add-placement-reading.component.html',
  styleUrls: ['./add-placement-reading.component.scss']
})
export class AddPlacementReadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
